import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MinDeviceDetails } from 'libs/portal/src/models/MinDeviceDetails';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { openDeviceEditDialog } from '../device-edit-modal/device-edit-modal.component';
import { UserRightsService } from '@huge-monorepo/portal/services';

@Component({
  selector: 'tools-device-details-card',
  templateUrl: './device-details-card.component.html',
  styleUrls: ['./device-details-card.component.scss'],
})
export class DeviceDetailsCardComponent implements OnInit, OnChanges {
  @Input() data: MinDeviceDetails;
  userHasWriteAccess: boolean = false;

  constructor(private tools: ToolsService, private dialogRef: MatDialog, private auth: UserRightsService) { }

  ngOnInit() {
    this.formatUsageValue();
    this.userHasWriteAccess = this.auth.GetUserPortalReadWrite().PortalWriteAccess;
  }

  formatUsageValue() {
    if (this.data?.InBundleAmount != null) {
      this.data['FormattedInBundleAmount'] = this.tools.FormatBundleUsage(this.data.InBundleAmount);
    }
    if (this.data?.Usage != null) {
      this.data['FormattedUsage'] = this.tools.FormatBundleUsage(this.data.Usage);
    }
  }

  openEditDevice(): void {
    openDeviceEditDialog(this.dialogRef, {
      DeviceID: this.data.ID,
      TerminalID: this.data.TerminalID,
      MerchantName: this.data.MerchantName,
      SerialNumber: this.data.SerialNumber,
      KaID: this.data.kaID,
    }).subscribe((res) => {
      if (res == null) return;
      this.data.TerminalID = res.TerminalID;
      this.data.MerchantName = res.MerchantName;
      this.data.SerialNumber = res.SerialNumber;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.formatUsageValue();
    }
  }
}
